import { uniqBy } from "lodash";
import { Payout, PayoutTransferPurpose } from "@wingspanhq/wingspan-api-sdk";
import { getFailedStatusCount } from "./getFailedStatusCount";
import { getDestinationName } from "./getDestinationName";
import {
  getTableStatus,
  PayoutTableStatus
} from "../utils/getPayoutsStatusPillProps";

export const getStatusDescriptionText = (
  payout: Payout
): string | undefined => {
  const tableStatus = getTableStatus(payout);

  switch (tableStatus) {
    case PayoutTableStatus.Deposited: {
      const uniqueTransfers = uniqBy(
        payout.transfers.filter(
          transfer =>
            (transfer.purpose === PayoutTransferPurpose.DISBURSEMENT ||
              transfer.purpose === PayoutTransferPurpose.WALLET_REMAINDER) &&
            transfer.destination
        ),
        transfer => transfer.destination?.resourceId
      );

      if (uniqueTransfers.length === 0) return "";
      if (uniqueTransfers.length === 1) {
        return getDestinationName(uniqueTransfers[0].destination!);
      }
      return `${uniqueTransfers.length} accounts`;
    }

    case PayoutTableStatus.Failed: {
      const { errorsLength, transfersLength } = getFailedStatusCount(payout);
      return `${errorsLength} of ${transfersLength}`;
    }

    default:
      return undefined;
  }
};
